import type { CustomNode, CustomEdge } from '@src/components/custom-nodes/types';
import type { SerializedNode, SerializedHashTable } from '@src/scenario-editor/utils/serializer/types';
import { dehydrateEdgeAttrs, dehydrateNodeAttrs } from '@src/scenario-editor/utils/serializer';

export const buildLinkedListHashTable = (nodes: CustomNode[], edges: CustomEdge[]) => {
  const dehydratedNodes = nodes.map(dehydrateNodeAttrs);
  const dehydratedEdges = edges.map(dehydrateEdgeAttrs);

  const nodeMap =
    new Map(dehydratedNodes.map(
      node => [node.id, { ...node, nextNodes: [], prevNodes: [] }]
    )) as Map<string, SerializedNode>;

  dehydratedEdges.forEach(edge => {
    const { source, target } = edge;
    const sourceNode = nodeMap.get(source)!;
    const targetNode = nodeMap.get(target)!;
    if (sourceNode && targetNode) {
      sourceNode.nextNodes.push(targetNode.id);
      targetNode.prevNodes.push(sourceNode.id);
    }
  });

  const hashTable = {} as SerializedHashTable;
  nodeMap.forEach((value, key) => {
    hashTable[key] = value;
  });

  return hashTable;
}
